<template>
    <div class="x_box A4">
        <div class="x_body">
            <div class="print-header" style="display: flex;">
                <div>
                    <img src="/img/logo1.png" width="140px">
                </div>
                <div style="padding: 20px; margin-left: 250px;">
                    <h5 class="text-center font-m">ផ្ទេរទំនិញ</h5>
                    <h5 class="text-center" style="font-weight: 600;">STOCK TRANSFER</h5>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <table style="width: 100%;">
                        <tbody>
                            <tr>
                                <td style="width: 100px;">{{ $t('branch_from') }}</td>
                                <td style="width: 10px;">:</td>
                                <td>{{header.FromBranchName}}</td>
                            </tr>
                            <tr>
                                <td style="width: 100px;">{{ $t('branch_to') }}</td>
                                <td style="width: 10px;">:</td>
                                <td>{{header.ToBranchName}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-sm-6">
                    <table align="right">
                        <tbody>
                        <tr>
                            <td>{{$t('code')}}</td>
                            <td>:</td>
                            <td>{{header.Num}}</td>
                        </tr>
                        <tr>
                            <td>{{$t('date')}}</td>
                            <td>:</td>
                            <td>{{$format(header.Date, 'DD/MM/YYYY')}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br>
            <div style="min-height: 900px;">
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-bordered table-sm">
                            <thead>
                            <tr>
                                <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                <th>{{$t('item_code')}}</th>
                                <th>{{$t('item_name')}}</th>
                                <th>{{$t('description')}}</th>
                                <th class="text-right">{{$t('qty')}}</th>
                                <th>{{$t('uom')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(ret,index) in lines" :key="index">
                                <td class="text-center">{{index + 1}}</td>
                                <td>{{ret.ItemCode}}</td>
                                <td>{{ret.ItemName}}</td>
                                <td>{{ret.Description}}</td>
                                <td class="text-right">{{ret.Quantity}}</td>
                                <td>{{ret.UomName}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div style="padding: 20px 0;">សំគាល់: {{header.Remark}}</div>
                    </div>
                </div>
            </div>
            <br/> 
            <div class="row">
                <div class="col-sm-12">
                    <div style="padding: 30px;">
                        <div class="flex-container" style="justify-content: space-between;">
                            <div class="text-center">
                                <div>រៀបរៀងដោយ</div>
                                <div>Prepared By</div>
                                <div style="margin-top: 85px;">
                                    <div>ឈ្មោះ និងហត្ថលេខា</div>
                                    <div>Name & Sign</div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div>អ្នកកាន់ស្តុក</div>
                                <div>Stock Supervisor</div>
                                <div style="margin-top: 85px;">
                                    <div>ឈ្មោះ និងហត្ថលេខា</div>
                                    <div>Name & Sign</div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div>ប្រគល់ដោយ</div>
                                <div>Released By</div>
                                <div style="margin-top: 85px;">
                                    <div>ឈ្មោះ និងហត្ថលេខា</div>
                                    <div>Name & Sign</div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div>អ្នកទទួល</div>
                                <div>Receiver</div>
                                <div style="margin-top: 85px;">
                                    <div>ឈ្មោះ និងហត្ថលេខា</div>
                                    <div>Name & Sign</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                company: {},
                header: {},
                lines: [],
                logo: '/img/logo2.png'
            }
        },
        created() {
            this.getCompany();
            var id = this.$route.params.id;
            if (id !== undefined && id != null && id !== '') {
                this.findById(id);
            }
        },
        methods: {
            getCompany: function () {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            },
            findById(id){
                let loading = this.$loading.show();
                this.$api().post('stock/transfer/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.header = res.data.Json.Header;
                        this.lines = res.data.Json.Lines;
                    }
                }).finally(function(){ loading.hide(); });
            },
        }
    }
</script>
<style scoped>
    .font-x *{
        font-size: 12pt;
    }
    .table-bordered th, .table-bordered td {
        border: 1px solid black;
    }
</style>